// extracted by mini-css-extract-plugin
export default {"wrapper":"ScreenButton_wrapper__0ABrj","primary":"ScreenButton_primary__51SZS","ghost":"ScreenButton_ghost__wBG05","outlined":"ScreenButton_outlined__1IC77"};